import { render, staticRenderFns } from "./OrderChangeHistory.vue?vue&type=template&id=0f628324&"
import script from "./OrderChangeHistory.vue?vue&type=script&lang=js&"
export * from "./OrderChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderChangeHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VTooltip})
